module.exports = {
  lang: {
    t1: `Halaman Utama`,
    t2: `Kad kunjungan`,
    t3: `Ikuti`,
    t4: `Orang yang boleh dihubungi`,
    t5: `Pesan`,
    t6: `Login`,
    t7: `Daftar`,
    t8: `Platform baru konektivitas bisnis global, medan baru untuk pemasaran digital perusahaan`,
    t9: `WeMeet - Login dengan Nombor Telefon Bimbit`,
    t10: `Nombor Telefon Bimbit`,
    t11: `Kod Pengesahan`,
    t12: `Sila masukkan nombor telefon bimbit anda`,
    t13: `Sila masukkan kod pengesahan`,
    t14: `Mendapat`,
    t15: `Login`,
    t16: `Sila masukkan nombor telefon bimbit dalam format yang betul`,
    t17: `Kod pengesahan telah dihantar`,
    t18: `Kod pengesahan yang dimasukkan tidak betul. Sila semak dan masukkan semula.`,
    t19: `Log masuk berjaya`,
    t20: `Kod pengesahan anda ialah (0). Sila gunakan dalam masa {1} minit.`,
    t21: `Batal`,
    t22: `Sahkan`,
    t23: `Maklum Balas`,
    t24: `Akun WeMeet anda belum lengkap. Segera ambil tindakan untuk menyelesaikan proses pendaftaran dan nikmati berbagai interaksi serta peluang tak terbatas.`,
    t25: `Menuju Pendaftaran`,
    t26: `Log masuk WeMeet melalui e-mel`,
    t27: `Nama akaun`,
    t28: `Masukkan alamat emel anda`,
    t29: `Kata laluan`,
    t30: `Masukkan kata laluan anda`,
    t31: `Lupa kata laluan?`,
    t32: `Log masuk`,
    t33: `Cara masuk lain`,
    t34: `Sudah mendaftar WeMeet Mini App? Gunakan sekarang.`,
    t35: `Log masuk dengan nombor telefon`,
    t36: `Sila masukkan emel anda terlebih dahulu.`,
    t37: `Sila masukkan kata laluan anda terlebih dahulu.`,
    t38: `Format emel tidak betul`,
    t39: `Jika anda mempunyai akaun WeMeet, anda boleh log masuk secara terus`,
    t40: `Log masuk`,
    t41: `Gambar profil`,
    t42: `Sila muat naik imej profil sebenar`,
    t43: `Nama penuh`,
    t44: `Nama pertama`,
    t45: `Nama keluarga`,
    t46: `Nama organisasi`,
    t47: `Sila masukkan nama institusi anda`,
    t48: `Jawatan`,
    t49: `Sila masukkan jawatan anda di institusi tersebut`,
    t50: `Alamat e-mel`,
    t51: `Masukkan alamat emel anda`,
    t52: `Nombor Telefon Bimbit`,
    t53: `Sila masukkan nombor telefon bimbit anda`,
    t54: `Kawasan`,
    t55: `Sila pilih kawasan`,
    t56: `Zon`,
    t57: `Sila pilih negeri, bandar dan daerah`,
    t58: `Alamat`,
    t59: `Sila masukkan alamat anda`,
    t60: `Saya telah membaca dan bersetuju dengan`,
    t61: `Terma Perkhidmatan`,
    t62: `Dasar Privasi`,
    t63: `Teruskan`,
    t64: `Sila tandakan perjanjian pengguna terlebih dahulu`,
    t65: `Sila masukkan nama anda`,
    t66: `Sila masukkan nama keluarga anda`,
    t67: `Sila masukkan emel anda terlebih dahulu`,
    t68: `Sila masukkan nama organisasi anda terlebih dahulu`,
    t69: `Format emel tidak betul`,
    t70: `Batal`,
    t71: `Selesai`,
    t72: `Sahkan nombor telefon mudah alih`,
    t73: `Nombor Telefon Bimbit`,
    t74: `Kod Pengesahan`,
    t75: `Sila masukkan kod pengesahan`,
    t76: `Mendapat`,
    t77: `Langkau pengesahan`,
    t78: `Hantar`,
    t79: `Telah disahkan`,
    t80: `Kod pengesahan yang dimasukkan tidak betul. Sila semak dan masukkan semula.`,
    t81: `Dihalangi`,
    t82: `Maklum Balas`,
    t83: `Nombor telefon yang anda masukkan telah didaftarkan dengan akaun WeMeet. Tiada keperluan untuk mendaftar semula, sila log masuk sekarang.`,
    t84: `Menuju halaman log masuk`,
    t85: `Maklum Balas`,
    t86: `Alamat email yang anda masukkan telah didaftarkan dengan akaun WeMeet. Tiada keperluan untuk mendaftar semula, sila log masuk sekarang.`,
    t87: `Menuju halaman log masuk`,
    t88: `Pautan pengesahan telah dihantar.`,
    t89: `Sila semak emel anda dan klik pautan untuk menyelesaikan pendaftaran.`,
    t90: `Faham`,
    t91: `Selamat datang ke WeMeet`,
    t92: `Selamat datang ke WeMeet! Sila tekan butang untuk menyelesaikan pendaftaran anda. Amaran mesra: Pautan ini sah selama 24 jam, sila bertindak dengan cepat.`,
    t93: `Pendaftaran Selesai`,
    t94: `E-mel anda telah diaktifkan. Sila masukkan kata laluan anda.`,
    t95: `Masukkan kata laluan`,
    t96: `Masukkan kata laluan anda`,
    t97: `Sahkan kata laluan`,
    t98: `Sila masukkan kata laluan anda sekali lagi`,
    t99: `Harus mengandungi gabungan huruf besar, huruf kecil, nombor, dan aksara khas, dengan panjang 8 hingga 20 aksara`,
    t100: `Masukkan kata laluan anda`,
    t101: `Sila masukkan kata laluan anda sekali lagi`,
    t102: `Kata laluan tidak sepadan`,
    t103: `Terima kasih telah menyelesaikan pendaftaran`,
    t104: `Anda telah masuk ke WeMeet. Anda boleh meneruskan tindakan sebelumnya.`,
    t105: `Teruskan pengalaman anda`,
    t106: `Maklum Balas`,
    t107: `Pautan telah tamat tempoh. Sila klik butang untuk memperoleh semula.`,
    t108: `Kirim semula`,
    t109: `Syarat dan ketentuan`,
    t110: `Dasar privasi`,
    t111: `Set semula kata laluan`,
    t112: `Sila masukkan akaun yang ingin anda set semula kata laluan`,
    t113: `Nama akaun`,
    t114: `Masukkan alamat emel anda`,
    t115: `Hantar`,
    t116: `Sila masukkan emel anda terlebih dahulu.`,
    t117: `Format emel tidak betul`,
    t118: `E-mel dihantar`,
    t119: `Sila semak emel anda, klik pautan dan tetapkan semula kata laluan anda.`,
    t120: `Faham`,
    t121: `Setel semula kata laluan - WeMeet`,
    t122: `Permintaan setel semula kata laluan anda telah disahkan, dan sistem telah mencipta pautan setel semula sementara. Amaran mesra: Pautan ini sah selama 24 jam, sila bertindak dengan cepat.`,
    t123: `Setel semula kata laluan`,
    t124: `Setel semula kata laluan berjaya`,
    t125: `Anda sudah log masuk ke WeMeet. Selamat datang semula.`,
    t126: `Menuju Laman Utama`,
    t127: `Orang yang boleh dihubungi`,
    t128: `Permintaan rakan baru`,
    t129: `Setuju`,
    t130: `Abaikan`,
    t131: `Disetujui`,
    t132: `Diabaikan`,
    t133: `Mengikuti`,
    t134: `Diikuti`,
    t135: `Pesan`,
    t136: `Permintaan belum diproses`,
    t137: `Sila masukkan nama atau nombor telefon anda`,
    t138: `Tidak ditemukan kandungan yang sesuai`,
    t139: `Tidak ada lagi yang tersedia`,
    t140: `Permohonan hubungan`,
    t141: `Setuju`,
    t142: `Abaikan`,
    t143: `Disetujui`,
    t144: `Diabaikan`,
    t145: `Ruang WeMeet AI`,
    t146: `Mengikuti`,
    t147: `Berhenti mengikuti`,
    t148: `vCard`,
    t149: `Sambungkan`,
    t150: `Hantar mesej`,
    t151: `Menunggu kelulusan`,
    t152: `Buang rakan`,
    t153: `Perkenalan diri`,
    t154: `Profil peribadi`,
    t155: `Maklum Balas`,
    t156: `Permohonan hubungan anda telah dihantar. Selepas diluluskan, anda akan secara automatik mengikuti beliau. Anda juga boleh memilih untuk mengikuti beliau segera untuk mengetahui maklumat lanjut mengenainya.`,
    t157: `Belum mengikuti`,
    t158: `Ikuti`,
    t159: `Mengikuti`,
    t160: `Batalkan hubungan rujukan`,
    t161: `Setelah membatalkan hubungan rujukan, pihak lain tidak boleh melihat maklumat peribadi anda lagi tetapi tidak akan secara serentak membatalkan peminat anda.`,
    t162: `Fikirkan semula`,
    t163: `Buang rakan`,
    t164: `Tindakan berjaya`,
    t165: `AI Pembantu WeMeet`,
    t166: `Sila masukkan soalan anda`,
    t167: `Hantar`,
    t168: `Harap perhatikan bahawa kandungan interaksi AI mungkin tidak tepat dan tidak mewakili pandangan platform.`,
    t169: `Kad pengenalan WeMeet`,
    t170: `Muat turun`,
    t171: `Edit kad pengenalan`,
    t172: `Muat turun kod QR`,
    t173: `Gambar telah dihasilkan. Sila simpan. Imbas kod QR untuk menyimpan maklumat hubungan.`,
    t174: `Gambar profil`,
    t175: `Sila muat naik imej profil sebenar`,
    t176: `Nama penuh`,
    t177: `Nama pertama`,
    t178: `Nama keluarga`,
    t179: `Sila masukkan nama anda`,
    t180: `Nama organisasi`,
    t181: `Sila masukkan nama institusi anda`,
    t182: `Jawatan`,
    t183: `Sila masukkan jawatan anda di institusi tersebut`,
    t184: `Alamat e-mel`,
    t185: `Masukkan alamat emel anda`,
    t186: `Nombor Telefon Bimbit`,
    t187: `Sila masukkan nombor telefon bimbit anda`,
    t188: `Kawasan`,
    t189: `Sila pilih kawasan`,
    t190: `Zon`,
    t191: `Sila pilih negeri, bandar dan daerah`,
    t192: `Alamat`,
    t193: `Sila masukkan alamat anda`,
    t194: `Sila masukkan nama anda`,
    t195: `Sila masukkan nama keluarga anda`,
    t196: `Sila masukkan emel anda terlebih dahulu`,
    t197: `Sila masukkan nama organisasi anda terlebih dahulu`,
    t198: `Format emel tidak betul`,
    t199: `Bilik bual`,
    t200: `Galeri gambar`,
    t201: `Ambil gambar`,
    t202: `Sila masukkan mesej anda`,
    t203: `Hantar`,
    t204: `Telah dibaca`,
    t205: `Belum dibaca`,
    t206: `Tempoh batalkan tamat`,
    t207: `Batal`,
    t208: `Gambar`,
    t209: `Album`,
    t210: `Mengambil gambar`,
    t211: `Memilih daripada Album`,
    t212: `Batal`,
    t213: `Gambar`,
    t214: `Potret`,
    t215: `Pratonton`,
    t216: `Selesai`,
    t217: `Ruang WeMeet AI`,
    t218: `Hubungi Kami`,
    t219: `Hubungi saya`,
    t220: `Nama penuh`,
    t221: `Institusi`,
    t222: `Jawatan`,
    t223: `Nombor telefon`,
    t224: `Alamat e-mel`,
    t225: `Kawasan`,
    t226: `Zon`,
    t227: `Alamat`,
    t228: `Sila masukkan nama anda`,
    t229: `Sila masukkan nama organisasi anda`,
    t230: `Sila masukkan jawatan anda`,
    t231: `Sila masukkan nombor telefon anda`,
    t232: `Sila masukkan alamat emel anda`,
    t233: `Sila pilih kawasan`,
    t234: `Sila pilih negeri, bandar dan daerah`,
    t235: `Sila masukkan alamat`,
    t236: `Niat`,
    t237: `Beli produk`,
    t238: `Produk ejen`,
    t239: `Kerjasama pasaran`,
    t240: `Lain-lain`,
    t241: `Sila masukkan nama anda`,
    t242: `Sila masukkan nama organisasi anda`,
    t243: `Sila masukkan alamat emel anda`,
    t244: `Format emel tidak betul`,
    t245: `Pesanan anda telah dihantar`,
    t246: `Tinggalkan mesej`,
    t247: `Sila masukkan kandungan pertanyaan anda`,
    t248: `Sahkan`,
    t249: `Sila log masuk atau daftar terlebih dahulu`,
    t250: `Pengikut`,
    t251: `Hubungi kami`,
    t252: `Produk`,
    t253: `Pasukan`,
    t254: `Pandangan keseluruhan`,
    t255: `Album`,
    t256: `Kebolehan`,
    t257: `Modal terdaftar`,
    t258: `Tarikh penubuhan`,
    t259: `Alamat terdaftar`,
    t260: `Sungai atas`,
    t261: `Sungai tengah`,
    t262: `Sungai bawah`,
    t263: `الصناعات المرتبطة`,
    t264: `Prosedur`,
    t265: `Simpan`,
    t266: `Telah disahkan`,
    t267: `Cina`,
    t268: `Inggeris`,
    t269: `Perancis`,
    t270: `Rusia`,
    t271: `Sepanyol`,
    t272: `Jepun`,
    t273: `Korea`,
    t274: `Indonesia`,
    t275: `Vietnam`,
    t276: `Jerman`,
    t277: `Turki`,
    t278: `Itali`,
    t279: `Portugis`,
    t280: `Thai`,
    t281: `Melayu`,
    t282: `Arab`,
    t283: `Nama pengguna atau kata laluan tidak betul`,
    t284: `Sila baca dan terima Terma Pengguna WeMeet terlebih dahulu`,
    t285: `Tiada kandungan berkaitan tersedia`,
    t286: `Jenis`,
    t287: `Sifat`,
    t288: `Butiran`,
    t289: `Lain-lain`,
    t290: `Jumlah produk keseluruhan 2 buah`,
    t291: `{1} menjemput anda untuk melawat WeMeet AI Space dari {2}`,
    t292: `Klik di sini untuk melihat contoh atau masukkan soalan:`,
    t293: `Segar`,
    t294: `Anda juga boleh klik pada kad nama di bawah untuk menambah kenalan dan mendapatkan maklumat lanjut:`,
    t295: `Belajar`,
    t296: `Mesyuarat Digital WeMeet`,
    t297: `Pameran Digital WeMeet`,
    t298: `บัตรนามส่วนและพื้นที่ WeMeet AI`,
    t299: `Bagaimana menjadi ahli organisasi WeMeet`,
    t300: `WeMeet Perkhidmatan Persidangan Digital menyediakan anda dengan penyelesaian mesyuarat dalam talian yang komprehensif, termasuk tetapi tidak terhad kepada penciptaan dan penerbitan mesyuarat, pengurusan pendaftaran peserta, daftar masuk elektronik, penjadualan mesyuarat, perkongsian bahan mesyuarat, perbincangan interaktif secara langsung, dan interaksi tetamu.`,
    t301: `WeMeet Pameran Digital, membantu membangun laman web rasmi mikro pameran dengan cepat. Memaparkan maklumat pameran, persembahan pameran, siaran langsung pameran, pendaftaran pameran, jadual acara, dan lain-lain, membolehkan syarikat yang menyertai dan penonton memahami dengan mudah butiran pameran. Untuk menggunakan ciri WeMeet Pameran Digital, sila lengkapkan proses pendaftaran institusi terlebih dahulu. Klik "Saya", gulir ke bawah ke "Pusat Perkhidmatan" - "Masuk Institusi" dan ikuti arahan untuk menyelesaikan proses pendaftaran.`,
    t302: `Pengguna peribadi WeMeet hanya perlu memberikan kebenaran ID WeChat, nombor telefon, dan lengkapkan pendaftaran platform untuk mendapatkan kad perniagaan digital peribadi dan mengekalkan Lounge AI peribadi mereka (termasuk resume peribadi, kemas kini, gambar, dokumen, dan lain-lain).`,
    t303: `Klik pada opsyen "Saya" di bar menu bawah mini-program untuk mengemaskini halaman kad perniagaan peribadi dan meningkatkan laman utama peribadi.`,
    t304: `Gabungan huruf besar dan kecil, nombor, dan tanda baca, dengan panjang antara 8-20 aksara.`,
    t305: `Masukkan nama produk`,
    t306: `Tiada lagi`,
    t307: `Klik sudut kanan atas`,
    t308: `Pilih cara berkongsi yang anda suka`,
    t309: `Saya faham`,
    t310: `Sila lengkapkan pendaftaran dan log masuk dahulu`,
    t311: `Ketahui lebih lanjut`,
    t312: `Produk Berkaitan`,
    t313: `Terima kasih kerana melawat`,
    t314: `Log Keluar`,
    t315: `Organisasi yang diikuti`,
    t316: `Sebelumnya`,
    t317: `Seterusnya`,
    t318: `Tiada`,
    t319: `{1} mengundang anda untuk melawat {2}`,
    t320: `Ruang AI belum mengekalkan bahasa semasa`,
    t321: `Ruang AI telah bertukar ke bahasa semasa`,
    t322: `Pautan telah diaktifkan`,
    t323: `Rangkaian sibuk, sila cuba lagi kemudian`,
    t324: `Perincian produk telah bertukar ke bahasa semasa`,
    t325: `Perincian produk tidak dijaga dalam bahasa ini pada masa ini`,
    t326: `Hai, saya adalah pembantu AI pintar WeMeet, bersedia memberikan perkhidmatan yang prihatin pada bila-bila masa! Bagaimana saya boleh membantu anda?`,
    t327: `Masukkan Nama`,
    t328: `Saya telah menjumpai maklumat hubungan yang berkaitan, sila semak kad hubungan di bawah.`,
    t329: `Lampiran`,
    t330: `Saya tidak menjumpai maklumat perhubungan yang berkaitan.`,
    t331: `Saya telah menghantar pertanyaan anda kepada rakan sekerja yang bertanggungjawab di bawah ini; anda juga boleh klik pada kad nama untuk menghubungi segera.`,
    t332: `Pameran`,
    t333: `Sila masukkan`,
    t334: `Pengguna`,
    t335: `Tiada lagi`,
    t336: `Berjaya segar semula`,
    t337: `Memuatkan`,
    t338: `Bebaskan untuk Muat Semula`,
  },
};

// 马来语
